function hasNodeDetails(node) {
  return Boolean(node.data?.description) || (Array.isArray(node.data?.resources) && node.data.resources.length > 0);
}

export function stabilizePublicNodePresentation(node) {
  const style = { ...node.style };
  const contextualOpacity = Number(style.opacity);
  delete style.opacity;
  delete style.transition;

  return {
    ...node,
    style: {
      ...style,
      cursor: hasNodeDetails(node) ? "pointer" : "default",
    },
    data: {
      ...node.data,
      contextualOpacity: Number.isFinite(contextualOpacity) ? contextualOpacity : 1,
    },
  };
}

export function requiresWindowsStableRendering(userAgent = "") {
  return /Windows/i.test(userAgent);
}

export function shouldDisablePublicOpacityTransitions(nodes, edges, focusMode = "disabled", userAgent = "") {
  // Hover focus now updates only the mounted presentation elements instead of
  // replacing React Flow's graph arrays. Dense non-Windows maps can therefore
  // retain the short opacity transition without destabilizing the canvas.
  // Windows keeps its stricter compositing safeguard.
  return requiresWindowsStableRendering(userAgent);
}

export function shouldUseClickOnlyPublicFocus({
  userAgent = "",
  nodes = [],
  edges = [],
  focusMode = "disabled",
} = {}) {
  // With contextual focus disabled, hover has no visual work to perform.
  // Avoid replacing the complete React Flow graph on every mouse entry/exit;
  // click handling remains available for node details and external resources.
  if (focusMode === "disabled" || focusMode === "off") return true;
  if (requiresWindowsStableRendering(userAgent)) return true;
  return false;
}
